import apiClient from "../utils/api";

class ColisService {
  async get(options = {}) {
    const params = new URLSearchParams();

    if (options.searchQuery) {
      params.append("q", options.searchQuery);
    }
    if (options.clientCode) {
      params.append("client_code", options.clientCode);
    }
    if (options.colisNumber) {
      params.append("colis_number", options.colisNumber);
    }
    if (options.sendingOption) {
      params.append("sending_option", options.sendingOption);
    }
    if (options.status) {
      params.append("status", options.status);
    }
    if (options.sortField && options.sortOrder) {
      params.append("sort_field", options.sortField);
      params.append("sort_order", options.sortOrder);
    }

    const endpoint = params.toString()
      ? `/colis?${params.toString()}`
      : "/colis";

    try {
      const response = await apiClient(endpoint, { method: "GET" });
      return response;
    } catch (error) {
      console.error("API Error:", error.message);
      throw error;
    }
  }

  async create(colisData) {
    return apiClient("/colis", {
      method: "POST",
      body: colisData,
    });
  }
  async getById(id) {
    return apiClient(`/colis/${id}`, { method: "GET" });
  }
  async update(id, colisData) {
    return apiClient(`/colis/${id}`, {
      method: "PUT",
      body: colisData,
    });
  }

  async delete(id) {
    return apiClient(`/colis/${id}`, { method: "DELETE" });
  }

  async exportData() {
    return apiClient("/colis/data", { method: "GET", responseType: "blob" });
  }
}
const colis_service = new ColisService();
export default colis_service;
